import { Auth } from 'aws-amplify'
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import * as R from 'ramda'

import config from '../config'

export const getLoginStatus = () => {
  const authCookie = Cookies.get(config.authCookieName)
  if (R.isNil(authCookie))
    return { isLoggedIn: false, error: 'UNDEFINED_JWT_ERROR' }
  let decodedJwt: {
    exp: number
    [key: string]: any
  }
  try {
    decodedJwt = jwtDecode(authCookie)
  } catch (e) {
    return { isLoggedIn: false, error: 'INVALID_JWT_ERROR' }
  }
  const exp = decodedJwt.exp * 1000
  const currentTime = new Date().getTime()
  if (currentTime > exp) {
    return { isLoggedIn: false, error: 'EXPIRED_JWT_ERROR' }
  }
  return { isLoggedIn: true }
}

export const getAuthHeader = async () => {
  let jwt = Cookies.get(config.authCookieName) ?? ''
  try {
    const emptyJWT = R.isNil(jwt)
    const jwtExpired = (cookieJwt: string) => {
      const decodedJwt: {
        exp: number
        [key: string]: any
      } = jwtDecode(cookieJwt)
      const exp = decodedJwt.exp * 1000
      const currentTime = Date.now()
      return currentTime > exp
    }
    const needRefreshJwtToken = emptyJWT || jwtExpired(jwt)
    if (needRefreshJwtToken) {
      const result = await Auth.currentSession()
      jwt = result.getAccessToken().getJwtToken()
      Cookies.set(config.authCookieName, jwt, {
        expires: config.cookies.defaultExpireTime
      })
    }
    return R.isNil(jwt) ? '' : `Bearer ${jwt}`
  } catch (e) {
    console.log(e)
  }
}

export const getUserInfo = () =>
  getLoginStatus().isLoggedIn
    ? jwtDecode(Cookies.get(config.authCookieName) as string)
    : null
